module.exports = __webpack_public_path__ + "img/vi-box.500cc649.png";